import idleTimer  from "idle-timer";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { hasAccess } from "../app/utils";
import GeneralLayout from "./Layouts/General";
import MainLayout from "./Layouts/Main";

/* Pages */
import { logout } from "../app/slices/authSlice";
import ApplicationForm from "../pages/applications/ApplicationForm";
import Applications from "../pages/applications/ApplicationList";
import Login from "../pages/auth/Login";
import RegisterExternal from "../pages/auth/RegisterExternal";
import Dashboard from "../pages/dashboard/Dashboard";
import ImportantDocuments from "../pages/importantDocuments/ImportantDocuments";
import NotFound from "../pages/notFound/NotFound";
import Reports from "../pages/reports/Reports";
import UserRequests from "../pages/users/UserRequests";
import UserList from "../pages/users/Users";
/* Pages */

const AppRoutes = () => {
  const dispatch = useDispatch();
  const { activeSession } = useSelector(({ auth }) => auth);
  let location = useLocation();
  let isUserAuthenticated =
    activeSession && activeSession?.hasOwnProperty("TOKEN") ? true : false;

  const onIdle = () => {
    if (activeSession?.hasOwnProperty("TOKEN")) dispatch(logout());
  };

  const onActive = () => {};

  idleTimer({
    callback: onIdle,
    activeCallback: onActive,
    idleTime: 300000,
  });

  //* builders
  const publicRoute = ({
    component: Component,
    path,
    layout: Layout,
    ...props
  }) => {
    if (isUserAuthenticated === true) {
      if (location?.pathname !== "/print") {
        return (
          <Route
            path={path}
            element={<Navigate to={"/dashboard"} state={{ from: location }} />}
          />
        );
      }
    }
    return (
      <Route
        path={path}
        element={
          <Layout>
            <Component {...props} />
          </Layout>
        }
      />
    );
  };

  const privateRoute = ({
    component: Component,
    layout: Layout,
    path,
    ...props
  }) => {
    if (isUserAuthenticated === false) {
      return (
        <Route
          path={path}
          element={<Navigate to={"/"} state={{ from: location }} />}
        />
      );
    }

    if (hasAccess({ type: "path", resource: location.pathname }) === false) {
      return (
        <Route
          path={path}
          element={<Navigate to={"/404"} state={{ from: location }} />}
        />
      );
    }
    return (
      <Route
        path={path}
        element={
          <Layout>
            <Component {...props} />
          </Layout>
        }
      />
    );
  };

  return (
    <Routes>
      {/* public routes */}
      {publicRoute({
        path: "/",
        component: Login,
        layout: GeneralLayout,
      })}

      {publicRoute({
        path: "/register-ext",
        component: RegisterExternal,
        layout: GeneralLayout,
      })}
      {/* public routes */}

      {/* private routes */}
      {privateRoute({
        path: "/dashboard",
        layout: MainLayout,
        component: Dashboard,
      })}
      {privateRoute({
        path: "/applications/apply",
        layout: MainLayout,
        component: ApplicationForm,
      })}
      {privateRoute({
        path: "/users/requests",
        layout: MainLayout,
        component: UserRequests,
      })}
      {privateRoute({
        path: "/users",
        layout: MainLayout,
        component: UserList,
      })}
      {privateRoute({
        path: "/applications",
        layout: MainLayout,
        component: Applications,
      })}
      {privateRoute({
        path: "/reports",
        layout: MainLayout,
        component: Reports,
      })}
      {privateRoute({
        path: "/importantDocuments",
        layout: MainLayout,
        component: ImportantDocuments,
      })}
      {/* private routes */}

      {/* Not Found*/}
      <Route
        element={
          isUserAuthenticated ? (
            <MainLayout>
              <NotFound />
            </MainLayout>
          ) : (
            <GeneralLayout>
              <NotFound />
            </GeneralLayout>
          )
        }
        path="/404"
      />
      <Route path="*" element={<Navigate to="404" />} />
    </Routes>
  );
};

export default AppRoutes;
